export const UserNotificationsEnum = {
   NoRedirect: 0,

   // Admin notifications
   AdminRegistration: 1,
   AdminWorkspaceRequest: 2,
   AdminAssessmentRequest: 3,
   AdminExpertRequest: 4,
   AdminAddedTicket: 5,
   AdminAddedTicketMessage: 6,


   //Ngo notifications
   NgoApprovedWorkspace: 7,
   NgoRejectedWorkspace: 8,
   NgoApprovedAssessment: 9,
   NgoRejectedAssessment: 10,
   NgoCompletedAssessment: 11,
   NgoAddedTicketMessage: 12,


   //Manager notifications
   ManagerAddedAssignee: 13,
   ManagerRemovedAssignee: 14,
   ManagerRequestedSubmit: 15,
   ManagerApprovedSubmitRequest: 22,
   ManagerRejectedSubmitRequest: 23,


   //Staff notifications
   StaffAddedAssignee: 16,
   StaffRemovedAssignee: 17,
   StaffApprovedSubmitRequest: 18,
   StaffRejectedSubmitRequest: 19,


   //Expert notifications
   ExpertAssessmentRequest: 20,


   //Approver notifications
   ApproverRequestedApproval: 21
};